module.exports = __webpack_public_path__ + "static/media/2019-Mustang-Convertible-V6.97dcf3f8.jpg";